import React from "react";
import { injectIntl } from "react-intl";
import classNames from "classnames";
import { CloseOutlined, MenuOutlined } from "@ant-design/icons";
import Globe from "../Lang";
import styles from "./index.module.less";
import { Link, useLocale } from "../../utils/i18n";

function Header(props) {
  const { intl, style, fade, placeholder } = props;
  const [active, setActive] = React.useState(false);
  const [locale] = useLocale();

  const links = (
    <>
      {/* <Link to="/">{intl.formatMessage({ id: "Home" })}</Link> */}
      <a href={`/support/?locale=${locale.split('-')[0]}`} >
        {intl.formatMessage({ id: 'Home' })}
      </a>
      {/* <a
        href={`https://privacy.mi.com/trust#/?locale=${locale.split('-')[0]}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({ id: 'Mi.Trust.Center' })}
      </a> */}
      <a
        href={`https://privacy.mi.com/all/${
          locale === "en"
            ? "en_US"
            : locale.replace(/-([a-z]+)$/, (_, s) => `_${s.toUpperCase()}`)
        }`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {intl.formatMessage({ id: "Privacy.Policy" })}
      </a>
    </>
  );

  return (
    <>
      <div
        className={classNames(
          styles.wrapper,
          !fade && styles.black,
          active && styles.active
        )}
        style={style}
      >
        <div className={styles.header}>
          <Link to="/" className={styles.brand}>
            {active ? (
              <span
                className={`${styles.logo} ${styles.logoDark} icon-logo`}
              ></span>
            ) : (
              <span className={`${styles.logo} icon-logo`}></span>
            )}
            <span className={styles.title}>
              {intl.formatMessage({ id: "Mi.Privacy.Support" })}
            </span>
          </Link>
          <div className={styles.meta}>
            <div className={styles.nav}>{links}</div>
            <Globe className={styles.locale} />
            <div
              className={styles.trigger}
              onClick={() => setActive((active) => !active)}
            >
              {active ? <CloseOutlined /> : <MenuOutlined />}
            </div>
          </div>
        </div>
        <div className={styles.menu}>{links}</div>
      </div>
      {placeholder && <div className={styles.placeholder} />}
    </>
  );
}

export default injectIntl(Header);
